import { render, staticRenderFns } from "./ConfirmLoginToCustomer.vue?vue&type=template&id=0df9b35d&scoped=true&"
import script from "./ConfirmLoginToCustomer.vue?vue&type=script&lang=js&"
export * from "./ConfirmLoginToCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmLoginToCustomer.vue?vue&type=style&index=0&id=0df9b35d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9b35d",
  null
  
)

export default component.exports